
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Character from '@/models/Character'
import Trait from '@/components/Trait'
import TraitModel from '@/models/Trait'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"trait"}}>{`Trait`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const character = Character.create({\n    attributes: [\n      { name: \'Strength\', value: 2 },\n      { name: \'Dexterity\', value: 4 },\n      { name: \'Perception\', value: 3 },\n    ],\n    traits: [\n      { name: \'Magical Aptitude\', value: 4 },\n      {\n        effects: [\n          {\n            condition: \'Vision-based\',\n            modifier: -5,\n            modifies: \'Perception\',\n          },\n        ],\n        name: \'Blind\',\n        value: -3,\n      },\n    ],\n  })\n  return (\n    <>\n      <Trait model={character.traits.at(0)} />\n      <Trait model={character.traits.at(1)} />\n    </>\n  )\n}'} __scope={{props: this ? this.props : props,Character,Trait,TraitModel}}>
  {() => {
    const character = Character.create({
      attributes: [
        { name: 'Strength', value: 2 },
        { name: 'Dexterity', value: 4 },
        { name: 'Perception', value: 3 },
      ],
      traits: [
        { name: 'Magical Aptitude', value: 4 },
        {
          effects: [{
            condition: 'Vision-based',
            modifier: -5,
            modifies: 'Perception',
          }],
          name: 'Blind',
          value: -3,
        },
      ]
    })
return (<>
  <Trait model={character.traits.at(0)} />
  <Trait model={character.traits.at(1)} />
</>)
  }}
</Playground>
           </MDXTag>
  }
}
  